import { matchPath, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Logout as LogoutIcon, Menu as MenuIcon } from '@mui/icons-material';
import { IconButton, Stack, Toolbar, Typography } from '@mui/material';

import { AppBarComponent } from './style';
import { RouterPaths } from '../../router/paths';
import { useAppActions, useAppSelector } from '../../utils/hooks';
import { layoutAction } from '../../store/sideBarStore/layoutStore';
import { headerTitleSelector, logoutURLSelector, sideBarSelector } from '../../store/selectors';
import Notifications from '../notification/notifications';

export const AppBar = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // variables
  const logoutURL = useAppSelector(logoutURLSelector);

  // calculation active path key for header
  const routerPathsValues = Object.values(RouterPaths);
  const activePath = routerPathsValues.filter((path) => matchPath(path, pathname))[0];
  const activePathKey = Object.keys(RouterPaths)[Object.values(RouterPaths).indexOf(activePath)];
  // layout actions logic
  const { openSideBar } = useAppActions(layoutAction);
  const isOpen = useAppSelector(sideBarSelector);
  const headerTitle = useAppSelector(headerTitleSelector);

  return (
    <>
      <AppBarComponent position="absolute" open={isOpen}>
        <Toolbar
          sx={{
            pr: '24px',
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => openSideBar()}
            sx={{
              marginRight: '36px',
              ...(isOpen && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>

          <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
            {headerTitle ? headerTitle : t(`ui.header.${activePathKey}`)}
          </Typography>

          <Stack direction="row" spacing={2}>
            <IconButton
              aria-label="logout"
              color="inherit"
              onClick={() =>
                window.location.replace(`${logoutURL}&return_to=${window.location.href}`)
              }
            >
              <LogoutIcon />
            </IconButton>

            <Notifications />
          </Stack>
        </Toolbar>
      </AppBarComponent>
    </>
  );
};
